var m = require('mithril');
var edit = require('../../layout/components/edit');
var columnForm = require('../../data/components/columnModal');
var heading = require('../../components/heading');
var elementtridataText = require('./elementtridataText')

function getPointWriteParentRid (elementRecord) {
  var locationRecord = elementRecord && elementRecord.location && elementRecord.location();
  return locationRecord && locationRecord['@class'] === 'Dashboard'
    ? elementRecord.parentRid
    : elementRecord && elementRecord['@rid'];
}

var elementTridata ={}

elementTridata.oninit= function (vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element;
  ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
}

elementTridata.view= function (vnode) {
  var ctrl = this;
    return m('div',[
      m(heading, {label: ctrl.element.name, class: 'f1', element: ctrl.element, parentReinitialize: ctrl.parentReinitialize, dashboardCallback: ctrl.dashboardCallback}),
      ctrl.element.out_Contains.map(function (outEdge) {
        var dataset = outEdge.in;
        if (!Array.isArray(dataset.out_Column)) {
          dataset.out_Column = []
        }
        if (edit.vm.editing() && dataset.out_Column.length == 0) {
          return m('div.tc.pv2', [
            m('i.icon.icon-right.ion-plus.blue', {onclick: columnForm.editDialogue.bind(columnForm, {out: dataset['@rid']}, { submitCallback: ctrl.parentReinitialize, columnNameRequired: true })})
          ])
        }
        return('div',[
          dataset.out_Column.map(function (column) {
            column.permission = ctrl.element.permission;
            return m(elementtridataText, {columnRecord: column, element: ctrl.element, parentReinitialize: ctrl.parentReinitialize, parentRid: getPointWriteParentRid(ctrl.element)})
          })
        ])
      })     
  ])
}
module.exports=elementTridata
